import { ApiService } from "./api.service";
export default class TypeService extends ApiService {
  namespace = "look-and-feel";
  icon = "BlueCube";
  name = "Type";
  favicon = "CubeBlue";
  action = "action";

  Width = 690;
  realm = 2;
  domain = 0;
  constructor() {
    super("types");
  }
}
